import useStyles from './PoolingRequestedDelivery.style'

type Props = {
    value: string,
    rowProps: {
        isOverdue: boolean,
    }
}

const PoolingRequestedDelivery = ({
    value,
    rowProps,
}: Props) => {
    const {
        classes,
    } = useStyles()

    return (
        <div className={rowProps?.isOverdue
            ? classes.red
            : classes.grey}
        >
            {value}
        </div>
    )
}

export default PoolingRequestedDelivery
